import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { setDateForTable, setInputDate } from '../../../utils/date';
import { formatNumberAmount } from '../../../utils/general';
import { Button, Card, CardBody, CardHeader, Col, Container, FormInput, FormSelect, Row } from 'shards-react';
import RangeDatePicker from '../../../components/common/RangeDatePicker';
import { bulk_delete_payroll_tax_data, download_payroll_tax_data, get_import_payroll_tax_list, get_pay_schedule_list, get_payperiod_list, get_payroll_data_list } from '../../../redux/actions/subscriber/payroll';
import ReactTable from 'react-table';
import { setAlert } from '../../../redux/actions/alert';
import ConfirmAlert from '../../../components/common/ConfirmAlert';

const DOWNLOAD = 'Download';
const DELETE = 'DELETE';
const PayrollTaxData = ({ get_payperiod_list, payPeriodList, get_import_payroll_tax_list
    , payrollTaxList, download_payroll_tax_data, bulk_delete_payroll_tax_data, setAlert
    , payScheduleList, get_pay_schedule_list
}) => {
    const initialData = {
        userId: '',
        client: '',
        workerName: '',
        processed: '',
        payPeriod: '',
        paySchedule: '',
        from: '',
        to: '',

        pageSizeOptions: [5, 10, 15, 20, 25, 30],
        pageSize: 10,
        bulkAction: '',
    }
    const [formData, setFormData] = useState(initialData);
    const { pageSize, pageSizeOptions } = formData;
    const [gridData, setGridData] = useState([]);
    const [filterPayPeriod, setFilterPayPeriod] = useState([]);

    const payScheduleListOptions = payScheduleList.map(paySchedule => <option key={paySchedule.payScheduleName + paySchedule.payScheduleRefNum} value={paySchedule.payScheduleRefNum}>{paySchedule.payScheduleName}</option>)
    let payPeriodListOptions = payPeriodList.map(item => <option key={item.refNum} value={item.payPeriodName}>{item.payPeriodName}</option>)
    //setFilterPayPeriod([payPeriodListOptions]);
    const tableRef = useRef()

    const [confirmAlert, setConfirmAlert] = useState({
        confirmMsg: "",
        visible: false,
        onConfirm: null
    });

    useEffect(() => {
        get_payperiod_list();
        get_import_payroll_tax_list('', '', '', '', '', 0, 0, '');
        get_pay_schedule_list();
    }, [])

    useEffect(() => {
        if(Object.keys(payrollTaxList).length > 0){
            let revisedData = { ...payrollTaxList };
            revisedData.payrollTaxDataList = payrollTaxList.payrollTaxDataList.map(x => { x.checked = false; return x; });
            setGridData(revisedData);
        }
    }, [payrollTaxList])

    useEffect(() => {
        if(formData.paySchedule !== null && formData.paySchedule !== ""){
            let filterData = payPeriodList.filter((x) => { return x.payScheduleRefNum == formData.paySchedule })
                .map(item => <option key={item.refNum} value={item.payPeriodName}>{item.payPeriodName}</option>)
            setFilterPayPeriod(filterData)
            console.log("filterData =", filterData)
        }
        else {
            setFilterPayPeriod([])
        }
    }, [formData.paySchedule])

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    let onStartDateChanged = (value) => {
        setFormData({ ...formData, from: value })
    }

    let onEndDateChanged = (value) => {
        setFormData({ ...formData, to: value })
    }

    const isAllChecked = () => {
        if(Object.keys(gridData).length > 0){
            for (let data of gridData?.payrollTaxDataList) {
            if (!data.checked)
                return false;
            }
            return true;    
        }
        return false;
        //if (gridData === undefined || gridData?.payrollTaxDataList?.length === 0) return false
        
    }

    const onCheck = (refNum) => {
        let data = { ...gridData }

        data.payrollTaxDataList = gridData.payrollTaxDataList.map(data => {
            if (data.refNum === refNum)
                data.checked = !data.checked
            return data;
        })
        setGridData(data);
    }

    const checkAll = (e) => {
        let data = { ...gridData }

        data.payrollTaxDataList = gridData.payrollTaxDataList.map(data => {
            data.checked = e.target.checked;
            return data;
        })
        setGridData(data);
    }

    const tableColumns = [
        {
            Header: <input type="checkbox" checked={isAllChecked()} onClick={(e) => checkAll(e)} />,
            accessor: "action", sortable: false,
            maxWidth: 50, minWidth: 50,
            Cell: row => <input type="checkbox" checked={row.original.checked} key={row.original.refNum} onClick={() => onCheck(row.original.refNum)} />
        },
        {
            Header: "User ID", accessor: "userId", className: "text-center",
            Footer: <div className="d-flex w-100 text-nowrap">
                <span><b>Total</b></span>
            </div>
        },
        {
            Header: "Client", accessor: "clientName", className: "text-center",
            Cell: row => <div title={row.original.clientName}>{row.original.clientName}</div>
        },
        {
            Header: "Worker Name", accessor: "userName", className: "justify-content-start",
            Cell: row => <div title={row.original.userName}>{row.original.userName}</div>
        },
        {
            Header: "Processed", accessor: "processed", className: "text-center",
            Cell: row => (row.original.processed ? 'True' : 'False')
        },
        {
            Header: "Date", accessor: "date", className: "text-center",
            Cell: row => setDateForTable(row.original.date)
        },
        {
            Header: "PPE", accessor: "payPeriodEnding", className: "text-center",
        },
        {
            Header: "Employee Name", accessor: "employeeName", className: "text-center",
            Cell: row => <div title={row.original.employeeName}>{row.original.employeeName}</div>
        },
        {
            Header: "Employee Number", accessor: "employeeNumber", className: "text-center",
        },
        {
            Header: "CPP Employee", accessor: "cppEmployee",
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.cppEmployee, 'en-US', 2)}</span>
            , Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(gridData.totalCppEmployee, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "CPP Employer", accessor: "cppEmployer",
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.cppEmployer, 'en-US', 2)}</span>
            , Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(gridData.totalCppEmployer, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "EI Employee", accessor: "eiEmployee",
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.eiEmployee, 'en-US', 2)}</span>
            , Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(gridData.totalEiEmployee, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "EI Employer", accessor: "eiEmployer",
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.eiEmployer, 'en-US', 2)}</span>
            , Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(gridData.totalEiEmployer, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "Federal Tax", accessor: "federalTax",
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.federalTax, 'en-US', 2)}</span>
            , Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(gridData.totalFederalTax, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "Prov Med", accessor: "provMed",
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.provMed, 'en-US', 2)}</span>
            , Footer: <div className="d-flex w-100 justify-content-end text-nowrap ">
                <span>{formatNumberAmount(gridData.totalProvMed, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "WCB", accessor: "wcb", maxWidth: 120, minWidth: 80,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.wcb, 'en-US', 2)}</span>
            , Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(gridData.totalWcb, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "Employer Total", accessor: "employerTotal",
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.employerTotal, 'en-US', 2)}</span>
            , Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(gridData.totalEmployerTotal, 'en-US', 2, 2)}</span>
            </div>
        },
    ];

    function downloadReport(e) {
        //e.preventDefault();
        let selecteList = gridData.payrollTaxDataList.filter(data => data.checked).map(mapData => mapData.refNum);
        if (selecteList !== undefined && selecteList.length > 0) {
            //call an API
            let apiJson = { refNumList: selecteList }
            download_payroll_tax_data(apiJson);
        }
        else {
            setAlert('Please select record(s) to download report', 'danger');
        }
    }

    function deleteSelected(e) {
        //e.preventDefault();
        
        let selecteList = gridData.payrollTaxDataList.filter(data => data.checked).map(mapData => mapData.refNum);
        if (selecteList !== undefined && selecteList.length > 0) {
            //call an API 
            let apiJson = { refNumList: selecteList }
            setConfirmAlert({
                ...confirmAlert,
                confirmMsg: 'Do you want to delete selected payroll tax?',
                visible: true,
                onConfirm: async () => {
                    await bulk_delete_payroll_tax_data(apiJson);
                    resetPayrollTaxData();
                }
            })
        }
        else {
            setAlert('Please select record(s) to delete payroll tax', 'danger');
        }
    }

    function searchPayrollTaxData(e) {
        e.preventDefault();
        const fromDate = setInputDate(formData.from);
        const toDate = setInputDate(formData.to);
        get_import_payroll_tax_list(formData.userId, formData.client, formData.workerName, formData.processed, formData.payPeriod, fromDate, toDate, formData.paySchedule);
    }

    function resetPayrollTaxData() {
        setFormData(initialData);
        get_import_payroll_tax_list('', '', '', '', '', 0, 0, "");
        get_payperiod_list();
        get_pay_schedule_list();
    }

    useEffect(() => {
        if(formData.bulkAction !== "" && formData.bulkAction !== undefined) {
            if(formData.bulkAction === DOWNLOAD) {
                downloadReport();
            }
            else {
                deleteSelected();
            }
        }
    }, [formData.bulkAction])

    return (
        <>
            <ConfirmAlert confirmAlert={confirmAlert} setConfirmAlert={setConfirmAlert} />
            <Container fluid className="main-content-container p-4">
                <div className="page-header flex-column flex-md-row py-2 d-flex justify-content-end bg-white tableSearch">
                    <div className="d-flex align-items-center p-1 ml-2">
                        <FormInput name='userId' value={formData.userId} size='50px'
                            onChange={onChange} placeholder="User Id" />
                    </div>

                    <div className="d-flex align-items-center p-1">
                        <FormInput name='client' value={formData.client}
                            onChange={onChange} placeholder="Client" />
                    </div>

                    <div className="d-flex align-items-center p-1">
                        <FormInput name='workerName' value={formData.workerName}
                            onChange={onChange} placeholder="Worker Name" />
                    </div>

                    <div className="d-flex align-items-center p-1">
                        <FormSelect
                            id="processed"
                            name="processed"
                            value={formData.processed}
                            onChange={onChange}>
                            <option key={`process`} value=''>Processed</option>
                            <option key={`true`} value='True'>True</option>
                            <option key={`false`} value='False'>False</option>
                        </FormSelect>
                    </div>
                    
                    <div className="d-flex align-items-center p-1">
                        <FormSelect
                            id="paySchedule"
                            name="paySchedule"
                            value={formData.paySchedule}
                            onChange={onChange}>
                            <option key={`status`} value=''>Select Pay Schedule</option>
                            {payScheduleListOptions}    
                        </FormSelect>
                    </div>

                    <div className="d-flex align-items-center p-1">
                        <FormSelect
                            id="payPeriod"
                            name="payPeriod"
                            value={formData.payPeriod}
                            onChange={onChange}>
                            <option key={`status`} value=''>Select Pay Period</option>
                            {/* {payPeriodListOptions} */}
                            {filterPayPeriod}
                        </FormSelect>
                    </div>

                    <div className="d-flex align-items-center p-1">
                        <RangeDatePicker className="justify-content-end" name="range"
                            startDate={formData.from} endDate={formData.to}
                            onStartDateChanged={onStartDateChanged} onEndDateChanged={onEndDateChanged} />
                    </div>

                    <div className="d-flex align-items-center justify-content-end p-1">
                        <Button className="mx-2 py-2 my-2" size='sm' theme="accent"
                            onClick={searchPayrollTaxData}
                        >Search</Button>

                        <Button className="mx-2 py-2 my-2"
                            onClick={resetPayrollTaxData}
                            size='sm' theme="accent">Reset</Button>
                    </div>
                </div>

                <div className="w-100">
                    <Card className="tableCard p-0">
                        <CardHeader className="p-0">
                            <Container fluid className="file-manager__filters border-bottom">
                                <Row>
                                    {/* Filters :: Page Size */}
                                    <Col lg="2" className="file-manager__filters__rows d-flex justify-content-center justify-content-md-start align-items-center cl-2">
                                        <span>
                                            <FormSelect size="sm" name='bulkAction' className="w-100"
                                                value={formData.bulkAction} onChange={onChange}
                                            >
                                                <option key="bulkActions0" value="">Bulk Actions</option>
                                                <option key="changeStatus1" value={DOWNLOAD}>Download</option>
                                                <option key="deleteProject" value={DELETE}>Delete</option>
                                            </FormSelect>
                                        </span>
                                    </Col>
                                    <Col lg="3" className="d-flex align-items-center">
                                    </Col>
                                    <Col lg="6" className="file-manager__filters__search d-flex justify-content-md-start col-7">
                                    </Col>
                                    <Col lg="1"
                                        className="file-manager__filters__rows d-flex justify-content-center justify-content-md-end align-items-center col-2">
                                        <span>Show</span>
                                        <FormSelect
                                            size="sm"
                                            name='pageSize'
                                            value={formData.pageSize}
                                            onChange={onChange}
                                        >
                                            {pageSizeOptions.map((size, idx) => (
                                                <option key={idx} value={size}>
                                                    {size} rows
                                                </option>
                                            ))}
                                        </FormSelect>
                                    </Col>
                                </Row>
                            </Container>
                        </CardHeader>
                        <CardBody className="p-0">
                            <div className="">
                                <ReactTable
                                    ref={tableRef}
                                    columns={tableColumns}
                                    data={gridData.payrollTaxDataList}
                                    pageSize={Number(pageSize)}
                                    showPageSizeOptions={false}
                                    resizable={false}
                                    noDataText="No results found"
                                />
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </Container>
        </>
    )
}
const mapStateToProps = (state) => ({
    payPeriodList: state.payroll.payPeriodList,
    payrollTaxList: state.payroll.payrollTaxList,
    payrolltaxDataList: state.payroll.payrolltaxDataList,
    payScheduleList: state.payroll.payScheduleList,
});

export default connect(mapStateToProps, {
    get_payperiod_list, get_import_payroll_tax_list
    , bulk_delete_payroll_tax_data, download_payroll_tax_data, setAlert
    , get_pay_schedule_list
})
    (PayrollTaxData)
